// store/counterSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCoins } from './coinsSlice';

const MODES = {
    PRIVATE: 'private',
    PUBLIC: 'public'
}

// Async thunk for switching mode and loading coins
export const switchMode = createAsyncThunk(
    'mode/switchMode',
    async (_, { dispatch, getState }) => {
        const currentMode = getState().mode.mode;
        const newMode = currentMode === MODES.PUBLIC ? MODES.PRIVATE : MODES.PUBLIC;
        
        // Switch the mode first
        dispatch(toggleMode());
        
        // Then fetch coins for the new mode
        await dispatch(getCoins(newMode));
        
        return newMode;
    }
);

// Load mode from localStorage or default to PUBLIC
const savedMode = localStorage.getItem('wallet_mode');
const initialState = {
    mode: savedMode && (savedMode === MODES.PRIVATE || savedMode === MODES.PUBLIC) ? savedMode : MODES.PUBLIC,
    switching: false // Track when mode is being switched
};

const modeSlice = createSlice({
    name: 'mode',
    initialState,
    reducers: {
        toggleMode: state => {
            state.mode = (state.mode === MODES.PUBLIC ? MODES.PRIVATE : MODES.PUBLIC)
            // Persist mode to localStorage
            localStorage.setItem('wallet_mode', state.mode);
        },
        setSwitching: (state, action) => {
            state.switching = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(switchMode.pending, (state) => {
                state.switching = true;
            })
            .addCase(switchMode.fulfilled, (state) => {
                state.switching = false;
            })
            .addCase(switchMode.rejected, (state) => {
                state.switching = false;
            });
    }
});

export const { toggleMode, setSwitching } = modeSlice.actions;
export default modeSlice.reducer;
